(function () {
  function init(root) {
    var nav = root.querySelector('.isf-nav');
    if (nav) {
      var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 12); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    root.querySelectorAll('[data-isf-switcher]').forEach(function (sw) {
      var tabs = sw.querySelectorAll('[data-isf-tab]');
      var panels = sw.querySelectorAll('[data-isf-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var i = tab.getAttribute('data-isf-tab');
          tabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-isf-panel') !== i; });
        });
      });
    });

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    root.querySelectorAll('[data-isf-order-btn]').forEach(function (btn) {
      if (reduce) { btn.classList.add('is-placed'); btn.textContent = '✓ Order placed'; return; }
      var placed = false;
      setInterval(function () {
        placed = !placed;
        btn.classList.toggle('is-placed', placed);
        btn.textContent = placed ? '✓ Order placed' : 'Place order';
      }, 2200);
    });

    var reveals = root.querySelectorAll('.isf-reveal');
    if (reduce || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -10% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    /* Store videos (testimonial cards + real-stores grid): click to play in place.
       Starting one pauses any other video playing on the page section. */
    root.querySelectorAll('[data-isf-video]').forEach(function (card) {
      var src = card.getAttribute('data-isf-video');
      if (!src || card.getAttribute('data-isf-bound')) return;
      card.setAttribute('data-isf-bound', '1');
      card.addEventListener('click', function () {
        if (card.classList.contains('is-playing')) return;
        root.querySelectorAll('.is-playing video').forEach(function (other) { other.pause(); });
        var v = card.querySelector('video');
        if (!v) {
          v = document.createElement('video');
          v.src = src; v.controls = true; v.playsInline = true; v.preload = 'auto';
          var poster = card.querySelector('.isf-tm__poster'); if (poster) v.poster = poster.src;
          card.insertBefore(v, card.querySelector('.isf-tm__shade'));
          v.addEventListener('pause', function () { if (v.ended || v.currentTime === 0) card.classList.remove('is-playing'); });
          v.addEventListener('ended', function () { card.classList.remove('is-playing'); });
        }
        card.classList.add('is-playing');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    });
  }
  function boot() { document.querySelectorAll('.isf').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('.isf'); if (r) init(r); });
})();